export const APIENDPOINTS: any = {
    /* auth api */
    LOGIN: 'api/account/login/',
    FORGOT_PASSWORD: 'api/account/forgotpassword/',
    RESET_PASSWORD: 'api/account/resetpassword/',
    S3_STATIC_UPLOAD: "api/account/staticupload/",
    CHANGE_PASSWORD: "api/account/updatepassword/",

    /* Access api */

    /* Department Module api */
    DEAPRTMENT_LIST: 'api/account/departmentlist/',
    DEAPRTMENT_CRUD: 'api/account/departmentcrud/',
    DEAPRTMENT_DROPDOWN_LIST: 'api/account/departmentdroplist/',

    /* Employee Module api */
    EMPLOYEE_LIST: 'api/admin/employeelist/',
    EMPLOYEE_CRUD: 'api/admin/employeeapi/',
    GUEST_EMPLOYEE_LIST: 'api/admin/guestlist/',

    /* Admin Module Api*/
    ADMIN_LIST: 'api/admin/adminlist/',
    ADD_ADMIN_DROPDOWN: 'api/admin/departmentemployeelist/',
    ADMIN_CREATE_API: 'api/admin/admincreate/',

    /* Issues Module api */
    ISSUES_LIST: 'api/admin/issueslist/',
    ISSUES_LIST_DOWNLOAD: 'api/admin/downloadreport/',
    ISSUES_CRUD: 'api/admin/issuereport/',
    ISSUES_TRACKER: 'api/admin/issuetracker/',
    ISSUES_FEEDBACK: 'api/admin/issuefeedback/',

    /* Dashboard Module api */
    DASHBOARD_ADMIN: 'api/admin/admindashboard/',

    NOTIFICATION_LIST: 'api/admin/notificationlist/',
    NOTIFICATION_STATUS: 'api/admin/updatenotification/',

    /**profile api */
    PROFILE_DETAILS: 'api/account/updateprofile/',
}